import { isString } from 'radash';
import { useClipFitFill } from './useClipFitFill';
import ConfirmationDialog from '@/components/organisms/ConfirmationDialog';
import Toggle from '@/components/atoms/Toggle';
import { classnames } from '@/libs/utils';
import TooltipV2 from '@/components/TooltipV2';

export const ClipToggleOptions = ({
  showNameCard,
  isSpeakerLabelOn,
  onNameCardToggle,
  showBorder,
  onBorderToggle,
  isBorderDisabled,
  isFitApplied,
  fitFillDisabledReason,
  disabledSpeakerLabelToggle
}: {
  showNameCard: boolean;
  isSpeakerLabelOn: boolean;
  onNameCardToggle: (value: boolean) => void;
  showBorder: boolean;
  onBorderToggle: (value: boolean) => void;
  isBorderDisabled: boolean;
  isFitApplied: boolean;
  fitFillDisabledReason: string | null;
  disabledSpeakerLabelToggle: boolean;
}) => {
  const isFitFillDisabled = isString(fitFillDisabledReason);
  const { isOpen, handleCancel, handleConfirm, changeFitMode } = useClipFitFill({
    fitOption: isFitApplied ? 'FILL' : 'FIT'
  });
  return (
    <>
      <div className="mt-5 font-medium">Options</div>
      <TooltipV2
        tooltipElement={
          <div
            className={classnames('mt-4 flex items-center space-x-2', isFitFillDisabled ? 'cursor-not-allowed' : '')}
          >
            <Toggle size="small" on={isFitApplied} onToggle={changeFitMode} disabled={isFitFillDisabled} />
            <div className="text-sm font-medium">Keep aspect ratio of speaker(s)</div>
          </div>
        }
        tooltipContent={fitFillDisabledReason ?? ''}
        tooltipId={`fit-fill-disabled-reason`}
        place="left"
        size="base"
        colorTheme="light"
        className="!px-3 !py-1.5 !text-sm"
        opacity={1}
        offset={24}
      />

      <div className="mt-4 flex items-center space-x-2">
        <Toggle
          size="small"
          on={isSpeakerLabelOn}
          onToggle={onNameCardToggle}
          disabled={disabledSpeakerLabelToggle || !showNameCard}
        />
        <div className="text-sm font-medium">Show name cards</div>
      </div>
      <div className="mt-4 flex items-center space-x-2">
        <Toggle size="small" on={showBorder} onToggle={onBorderToggle} disabled={isBorderDisabled} />
        <div className="text-sm font-medium">Inset layout & add borders</div>
      </div>

      <ConfirmationDialog
        isOpen={isOpen}
        title="Confirm Fit Change"
        content="This will update all existing scenes with your current selection. Do you want to continue?"
        confirmLabel="Continue"
        cancelLabel="Cancel"
        onClose={handleCancel}
        onConfirm={handleConfirm}
      />
    </>
  );
};
